import { render, staticRenderFns } from "./RecommendEdit.vue?vue&type=template&id=8517ef5c&scoped=true&"
import script from "./RecommendEdit.vue?vue&type=script&lang=js&"
export * from "./RecommendEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8517ef5c",
  null
  
)

export default component.exports